var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.680154 5.5H7.4159C7.91874 5.5 8.1859 4.90453 7.85165 4.52799L4.48407 0.736265C4.42945 0.674561 4.36236 0.62516 4.28724 0.591328C4.21213 0.557495 4.13069 0.540001 4.04832 0.540001C3.96595 0.540001 3.88451 0.557495 3.8094 0.591328C3.73428 0.62516 3.6672 0.674561 3.61257 0.736265L0.243821 4.52799C-0.0904291 4.90453 0.176738 5.5 0.680154 5.5Z",
    fill: "#1E293B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAsc);
export default __webpack_public_path__ + "static/media/sortASC.535d9e662b21b30c15e184d0e67205a3.svg";
export { ForwardRef as ReactComponent };